import { render, staticRenderFns } from "./PicShow.vue?vue&type=template&id=3018fe14&"
import script from "./PicShow.vue?vue&type=script&lang=js&"
export * from "./PicShow.vue?vue&type=script&lang=js&"
import style0 from "./PicShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports